export const productData = {
  checking: [
    {
      name: "Freedom Checking Account",
      description: "Not your standard checking account - no minimum balance, access early direct deposit",
      details: {
        intro: "Open your checking account and you become a part owner of Pinnacle - with all the benefits of membership and your account earns monthly dividends. You'll receive a free ATM card and by applying online, you'll automatically be enrolled in e-Statements.",
        features: [
          {
            title: "$0 Monthly Fee",
            description: "With $50 min. balance."
          },
          {
            title: "Insured up to $1 million",
            description: "FDIC and/or NCUA insurance"
          },
          {
            title: "Free ATM Access",
            description: "Access to over 30,000 fee-free ATMs nationwide"
          }
        ]
      }
    },
    {
      name: "Eagle Checking Account",
      description: "Earn higher deposit dividends, experience loan rebates, access early direct deposit",
      details: {
        intro: "The Eagle Checking Account offers premium features for members who maintain higher balances or use Pinnacle as their primary financial institution.",
        features: [
          {
            title: "Premium Interest Rates",
            description: "Earn 0.25% APY on balances over $2,500"
          },
          {
            title: "Loan Rate Discounts",
            description: "0.25% discount on qualifying Pinnacle loans"
          },
          {
            title: "Free Checks",
            description: "First order of standard checks is free"
          }
        ]
      }
    },
    {
      name: "Entrepreneur Checking Account",
      description: "Not your standard checking account - earn higher deposit dividends, experience loan rebates",
      details: {
        intro: "Designed specifically for small business owners and entrepreneurs, this account provides the tools you need to manage your business finances effectively.",
        features: [
          {
            title: "Business Tools",
            description: "Free access to business accounting software"
          },
          {
            title: "Cash Management",
            description: "Deposit up to $10,000 cash per month with no fee"
          },
          {
            title: "Dedicated Support",
            description: "Access to business banking specialists"
          }
        ]
      }
    }
  ],
  savings: [
    {
      name: "Basic Savings Account",
      description: "Start with just $5, no monthly fees, access to high-yield options",
      details: {
        intro: "Our Basic Savings Account is perfect for those just starting their savings journey. With a minimum deposit of just $5, you can begin building your financial future.",
        features: [
          {
            title: "Low Minimum Balance",
            description: "Just $5 to open and maintain"
          },
          {
            title: "No Monthly Fees",
            description: "Keep more of your money working for you"
          },
          {
            title: "Quarterly Statements",
            description: "Track your progress with regular updates"
          }
        ]
      }
    },
    {
      name: "High-Yield Savings Account",
      description: "Earn 4.25% APY* on your entire balance with no maximum limit",
      details: {
        intro: "Our High-Yield Savings Account offers a competitive interest rate that applies to your entire balance, helping your money grow faster.",
        features: [
          {
            title: "Competitive Rate",
            description: "4.25% APY* on all balances"
          },
          {
            title: "No Maximum Balance",
            description: "Earn the same great rate on all your savings"
          },
          {
            title: "Online Access",
            description: "Manage your account 24/7"
          }
        ]
      }
    },
    {
      name: "Goal Savings Account",
      description: "Create separate savings buckets for different goals, no minimum balance",
      details: {
        intro: "The Goal Savings Account allows you to create multiple virtual accounts for different savings goals, making it easier to track your progress.",
        features: [
          {
            title: "Multiple Goals",
            description: "Create up to 10 separate savings goals"
          },
          {
            title: "Automatic Transfers",
            description: "Schedule regular contributions to each goal"
          },
          {
            title: "Visual Progress Tracking",
            description: "See how close you are to reaching each goal"
          }
        ]
      }
    }
  ],
  loans: [
    {
      name: "Personal Loan",
      description: "Flexible terms, competitive rates, no prepayment penalties",
      details: {
        intro: "Our Personal Loans provide the financial flexibility you need for life's expenses, from home improvements to debt consolidation.",
        features: [
          {
            title: "Competitive Rates",
            description: "Starting at 7.99% APR* for qualified borrowers"
          },
          {
            title: "Flexible Terms",
            description: "Choose terms from 12 to 60 months"
          },
          {
            title: "No Prepayment Penalty",
            description: "Pay off your loan early without additional fees"
          }
        ]
      }
    },
    {
      name: "Auto Loan",
      description: "New and used vehicle financing with rates as low as 3.99% APR*",
      details: {
        intro: "Drive away in your dream car with our competitive Auto Loan options for both new and used vehicles.",
        features: [
          {
            title: "Low Rates",
            description: "As low as 3.99% APR* for qualified borrowers"
          },
          {
            title: "Flexible Terms",
            description: "Terms up to 84 months available"
          },
          {
            title: "Quick Approval",
            description: "Pre-approval in as little as 15 minutes"
          }
        ]
      }
    },
    {
      name: "Home Equity Loan",
      description: "Access your home's equity with fixed rates and terms",
      details: {
        intro: "Put your home's equity to work with our Home Equity Loan, offering fixed rates and predictable monthly payments.",
        features: [
          {
            title: "Fixed Rates",
            description: "Lock in your rate for the life of the loan"
          },
          {
            title: "Tax Benefits",
            description: "Interest may be tax-deductible (consult your tax advisor)"
          },
          {
            title: "No Application Fees",
            description: "Save on upfront costs when you apply"
          }
        ]
      }
    }
  ],
  certificates: [
    {
      name: "6-Month Certificate",
      description: "Earn 5.55% APY* with a low minimum deposit of $500",
      details: {
        intro: "Our 6-Month Certificate offers a great short-term investment option with a competitive rate and the security of federal insurance.",
        features: [
          {
            title: "High Yield",
            description: "5.55% APY* guaranteed for the full term"
          },
          {
            title: "Low Minimum",
            description: "Start with just $500"
          },
          {
            title: "FDIC Insured",
            description: "Your investment is protected up to $250,000"
          }
        ]
      }
    },
    {
      name: "12-Month Certificate",
      description: "Earn 5.75% APY* with a $1,000 minimum deposit",
      details: {
        intro: "Our 12-Month Certificate provides a higher yield for those who can commit their funds for a full year.",
        features: [
          {
            title: "Higher Yield",
            description: "5.75% APY* locked in for 12 months"
          },
          {
            title: "Reasonable Minimum",
            description: "$1,000 minimum deposit required"
          },
          {
            title: "Automatic Renewal",
            description: "Option to automatically renew at maturity"
          }
        ]
      }
    },
    {
      name: "24-Month Certificate",
      description: "Earn our highest rate of 6.00% APY* with a $2,500 minimum",
      details: {
        intro: "For those looking to maximize their returns, our 24-Month Certificate offers our highest rate with the security of a fixed term.",
        features: [
          {
            title: "Premium Rate",
            description: "6.00% APY* guaranteed for two years"
          },
          {
            title: "Higher Minimum",
            description: "$2,500 minimum deposit required"
          },
          {
            title: "Dividend Options",
            description: "Choose to reinvest dividends or have them paid out"
          }
        ]
      }
    }
  ]
}